module.exports = __webpack_public_path__ + "assets/img/Spark-Systems-Website-w540.c6b168e4.jpg";